import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';

import EngineOilCard from '@/features/engineoil/card/EngineOilCard';
import Preconditions from '@/features/engineoil/preconditions/common/Preconditions';
import CustomerDetailsDialog from '@/features/engineoil/table/dialogs/CustomerDetailsDialog';
import TableSettingsDialog from '@/features/engineoil/table/dialogs/TableSettingsDialog';
import WorkshopDetailsDialog from '@/features/engineoil/table/dialogs/WorkshopDetailsDialog';
import EngineOilTablePage from '@/features/engineoil/table/EngineOilTablePage';
import { LoadingIndicator } from './LoadingIndicator';

// Dev-only mock gallery; lazy import keeps the mocks out of the production bundle
const DevCardGallery = import.meta.env.DEV ? lazy(() => import('./DevCardGallery')) : null;

const MainComponent = () => (
    <div className={'display-flex flex-column'}>
        <Suspense fallback={<LoadingIndicator />}>
            <Routes>
                {DevCardGallery && <Route path="/dev" element={<DevCardGallery />} />}
                <Route path="/table" element={<EngineOilTablePage />} />
                <Route path="/table/settings" element={<TableSettingsDialog />} />
                <Route path="/table/:assetId/assignment" element={<CustomerDetailsDialog />} />
                <Route path="/table/:workshopId/workshop" element={<WorkshopDetailsDialog />} />
                <Route path="/:assetId" element={<EngineOilCard />} />
                <Route path="/:assetId/preconditions" element={<Preconditions />} />
            </Routes>
        </Suspense>
    </div>
);

export default MainComponent;
